import React from 'react';

import style from './updateUserPasswordModal.module.css';
import userStyle from '../userManagement.module.css';
import commonStyles from '../../../common/common.module.css';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { Button, Grid, InputAdornment, OutlinedInput, createStyles, Theme, withStyles } from '@material-ui/core';
import { RotateLeft, Check, Clear } from '@material-ui/icons';
import {isPasswordSecure} from '../../../../utils/authentication';

interface UpdateUserPasswordModalProps { 
  name: string;
  email: string;
  role: string;
  newPassword: string;
  modalOpen: boolean;
  handleClose: () => void;
  handleChange: (e: any) => void;
  updateAndPrint: () => void;
  classes: any;
};

const styles = (theme: Theme) =>

  createStyles({
    titleColor: {
      color: 'var(--primaryblue)',
      fontWeight: 600,
      fontSize: '13px',
      minWidth: '110px'
    },
    gridData: {
      fontSize: '13px'
    },
  });

const UpdateUserPasswordModal = (props: UpdateUserPasswordModalProps) => {
  let {allTypesCharsPassword, valid, atLeast8CharPassword} = isPasswordSecure(props.newPassword);

  return (
    <Dialog
      open={ props.modalOpen }
      onClose={ props.handleClose }
      aria-labelledby="form-dialog-title"
      maxWidth={ 'sm' }
      fullWidth={true}
    >
      <DialogTitle id="form-dialog-title" >
        <div className={ style.dialogTitle }>
          <span className={ style.name }>Manage password</span>
          <IconButton aria-label="Close" className={ style.close } onClick={ props.handleClose }>
            <CloseIcon color='primary' />
          </IconButton>
        </div>
        <hr />
      </DialogTitle>
      <DialogContent>
        <div className={ `${ commonStyles.wrapper } ${ commonStyles.mb0 }` }>
        <Grid container className={style.gridContainer}>
            <Grid item xs={4} className={props.classes.titleColor}>
              Name:
            </Grid>
            <Grid item xs={6} className={props.classes.gridData}>
              {props.name}
            </Grid>
          </Grid>
          <Grid container className={style.gridContainer}>
            <Grid item xs={4} className={props.classes.titleColor}>
              Email/Username:
            </Grid>
            <Grid item xs={6} className={props.classes.gridData}>
              {props.email}
            </Grid>
          </Grid>
          <Grid container className={style.gridContainer}>
            <Grid item xs={4} className={props.classes.titleColor}>
              Role:
            </Grid>
            <Grid item xs={6} className={props.classes.gridData}>
              {props.role}
            </Grid>
          </Grid>
          <OutlinedInput
            id="newPassword"
            labelWidth={0}
            name="newPassword"
            fullWidth={true}
            error={!isPasswordSecure(props.newPassword).valid}
            onChange={props.handleChange}
            value={props.newPassword}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="Generate random password"
                  onClick={() => {props.handleChange({target: {name: 'newPassword', value: generatePassword(10)}})}}
                >
                  <RotateLeft />
                </IconButton>
              </InputAdornment>
            }
          />
        </div>
        <br/>
        <div className={style.passwordPolicyContainer}>
          <div className={style.passwordPolicyHeader}>
              Password Policy:
          </div>
          <div className={style.passwordPolicyConditions}>
            {atLeast8CharPassword ? <Check style={{ color: 'green', fontSize: '14px' }} /> : <Clear style={{ color: 'red', fontSize: '14px' }} />} <span className={style.greyText}>Must be at least 8 characters</span>
          </div>
          <div className={style.passwordPolicyConditions}>
            {allTypesCharsPassword ? <Check style={{ color: 'green', fontSize: '14px' }} /> : <Clear style={{ color: 'red', fontSize: '14px' }} />} <span className={style.greyText}>Must contain one upper case letter, one number and a special character</span>
          </div>
        </div>
        <div className={ `${ userStyle.buttonContainer } ${ commonStyles.fSpaceBtw }` } >
          <Button
            color="primary"
            variant="contained"
            onClick={props.handleClose}
          >Close</Button>
          <Button
            color="primary"
            variant="contained"
            onClick={props.updateAndPrint}
          >Update and print</Button>
        </div>
      </DialogContent>
    </Dialog>
  )
};

function generatePassword(pLength: number) {
  let keyListAlpha="abcdefghijklmnopqrstuvwxyz",
        keyListCapAlpha="ABCDEFGHIJKLMNOPQRSTUVWXYZ",
        keyListInt="123456789",
        keyListSpec="!@#_",
        password='';
    let len = Math.ceil(pLength/2);
    len = len - 3;
    let lenSpec = 1;
    let lenCap = pLength - lenSpec - len;

    for (let i=0;i<len;i++) {
        password+=keyListAlpha.charAt(Math.floor(Math.random()*keyListAlpha.length));
        password+=keyListInt.charAt(Math.floor(Math.random()*keyListInt.length));
    }

    for (let i=0;i<lenSpec;i++)
      password+=keyListSpec.charAt(Math.floor(Math.random()*keyListSpec.length));
    for (let i=0;i<lenCap;i++)
      password+=keyListCapAlpha.charAt(Math.floor(Math.random()*keyListCapAlpha.length));

    password=password.split('').sort(function(){return 0.5-Math.random()}).join('');

    return password;
}

export default withStyles(styles)(UpdateUserPasswordModal);